import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation BulkUpdateSpaceRecords(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordIds: [ID!]!
    $update: SpaceRecordUpdate!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                bulkUpdateSpaceRecords(ids: $spaceRecordIds, update: $update)
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.BulkUpdateSpaceRecordsMutation,
    readonly ents.extra.space.Record.Id[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'bulkUpdateSpaceRecords',
                graphql.transformers.OUT.default(
                  graphql.transformers.OUT.list(
                    graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.extra.space.Record.Id.isId,
                    ),
                  ),
                  [],
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.BulkUpdateSpaceRecordsMutation,
  readonly ents.extra.space.Record.Id[],
  graphql.schema.BulkUpdateSpaceRecordsMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
